/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TourCardProcessingMutationVariables = {
    tourId: string;
};
export type TourCardProcessingMutationResponse = {
    readonly tourDelete: {
        readonly clientMutationId: string | null;
    };
};
export type TourCardProcessingMutation = {
    readonly response: TourCardProcessingMutationResponse;
    readonly variables: TourCardProcessingMutationVariables;
};



/*
mutation TourCardProcessingMutation(
  $tourId: ID!
) {
  tourDelete(input: {tourId: $tourId}) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tourId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "tourId",
            "variableName": "tourId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "TourDeletePayload",
    "kind": "LinkedField",
    "name": "tourDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourCardProcessingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourCardProcessingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cb2be352eba0c660eabb5ea00cea418f",
    "id": null,
    "metadata": {},
    "name": "TourCardProcessingMutation",
    "operationKind": "mutation",
    "text": "mutation TourCardProcessingMutation(\n  $tourId: ID!\n) {\n  tourDelete(input: {tourId: $tourId}) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b1f92e26de2ffc97a6dda0ad556c37b9';
export default node;
